import axios from "axios";
import { ACCOUNT_SETUP, ARTWORK_CREATE, ARTWORK_DELETE, ARTWORK_LIST, ARTWORK_UPDATE, CHECKOUT_SUBSCRIPTION, FORGOT_PASSWORD, FORGOT_PASSWORD_OTP, GET_ART_MEDIUMS, GET_CHAT_MESSAGES, GET_CHATS, GET_CHECKOUT_SUBSCRIPTION_PLAN, GET_INVOICES, GET_MEDIUMS, GET_NOTIFICATION_COUNT, GET_NOTIFICATIONS, GET_STATUS, GET_SUBSCRIPTION_PLAN, GET_TERMS_CONDITIONS, LOGIN_THIRD_PARTY, LOGINADMIN, LOGOUT, PROFILE_GET, PROFILE_UPDATE, REFRESH_TOKEN_API, RESEND_OTP, RESET_PASSWORD, SEND_MESSAGE, SIGNUP, UPDATE_STUDIO, VERIFY_OTP } from "./Api";

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("hoast_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem("hoast_refresh_token");

        const res = await axios.post(REFRESH_TOKEN_API, {
          refresh_token: refreshToken,
        });

        console.log(res);
        const newAccessToken = res?.data?.data?.access_token;
        localStorage.setItem("hoast_token", newAccessToken);

        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return axios(originalRequest);
      } catch (refreshError) {
        console.error("Refresh token failed:", refreshError);
        localStorage.removeItem('hoast_token')
        localStorage.removeItem('hoast_refresh_token')
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export const loginApi = (params) => {
  return axios.post(LOGINADMIN, params);
};

export const signupAPI = (params) => {
  return axios.post(SIGNUP, params);
};

export const verifyOTP = (params) => {
  return axios.post(VERIFY_OTP, params);
};

export const resendOTP = (params) => {
  return axios.post(RESEND_OTP, params);
};

export const forgotPasswordOTP = (params) => {
  return axios.post(FORGOT_PASSWORD_OTP, params);
};

export const forgotPassword = (params) => {
  return axios.post(FORGOT_PASSWORD, params);
};

export const logoutAPI = (params) => {
  return axios.post(LOGOUT, params);
};

export const getMediumsAPI = (params) => {
  return axios.get(GET_ART_MEDIUMS, params);
};

export const getStatusAPI = (params) => {
  return axios.get(GET_STATUS, params);
};

export const accountSetupAPI = (params) => {
  return axios.post(ACCOUNT_SETUP, params);
};

export const artworkListAPI = (params) => {
  return axios.get(ARTWORK_LIST, { params: params });
};

export const createArtworkAPI = (params) => {
  return axios.post(ARTWORK_CREATE, params);
};

export const editArtworkAPI = (params) => {
  return axios.put(ARTWORK_UPDATE, params);
};

export const deleteArtworkAPI = (params) => {
  return axios.delete(ARTWORK_DELETE, { params: params });
};

export const updateProfileAPI = (params) => {
  return axios.put(PROFILE_UPDATE, params);
};

export const getProfileAPI = () => {
  return axios.get(PROFILE_GET);
};

export const updateStudioAPI = (params) => {
  return axios.put(UPDATE_STUDIO, params);
};

export const resetPasswordAPI = (params) => {
  return axios.post(RESET_PASSWORD, params);
};

export const getChatsAPI = (params) => {
  return axios.get(GET_CHATS, { params: params });
};

export const getChatMessagesAPI = (params) => {
  return axios.get(GET_CHAT_MESSAGES, { params: params });
};

export const sendMessageAPI = (params) => {
  return axios.post(SEND_MESSAGE, params);
};

export const getNotificationsAPI = (params) => {
  return axios.get(GET_NOTIFICATIONS, { params: params });
};

export const loginThirdPartyAPI = (params) => {
  return axios.post(LOGIN_THIRD_PARTY, params);
};

export const getNotificationCountAPI = () => {
  return axios.get(GET_NOTIFICATION_COUNT);
};

export const getInvoicesAPI = (params) => {
  return axios.get(GET_INVOICES, { params: params });
};

export const getTermsConditionsAPI = (params) => {
  return axios.get(GET_TERMS_CONDITIONS, { params: params });
};

export const getSubscriptionPlanAPI = (token) => {
  return axios.get(GET_SUBSCRIPTION_PLAN, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

export const checkoutSubscriptionAPI = (params) => {
  return axios.post(CHECKOUT_SUBSCRIPTION, {}, { params: params });
};

export const getCheckoutSubscriptionPlanAPI = () => {
  return axios.get(GET_CHECKOUT_SUBSCRIPTION_PLAN);
};